
export const GET_CUSTOMIZE_ORDER_FOR_ADMIN = "GET_CUSTOMIZE_ORDER_FOR_ADMIN"
export const GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS = "GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS"
export const GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR = "GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR"

export const UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN = "UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN"
export const UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS = "UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS"
export const UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR = "UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR"